import { axiosClient } from '@nx-frontend/shared/api';
import { randomString } from '@nx-frontend/shared/utils';

export async function buyPortalInternalApi({
  superSecret,
  subscriptionId,
  params,
}: {
  superSecret: string;
  subscriptionId: string;
  params: {
    code: string;
    increase: number;
  };
}): Promise<number> {
  const idempotencyKey = randomString(32);
  // TODO: move endpoint to next, no service to buy portal for now
  const response = await axiosClient.post(
    `/v1/billing/subscriptions/${subscriptionId}/purchase-addons?idempotencyKey=${idempotencyKey}&revertOnFailure=false`,
    params,
    {
      secret: superSecret,
    }
  );
  return response.status;
}
